// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueI18n from "vue-i18n";
import VueMatomo from "vue-matomo";

import axios from "axios";
import VueAxios from "vue-axios";
// import vueSmoothScroll from 'vue-smooth-scroll'

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import App from "./App.vue";
import router from "./router";
import Navbar from "@/views/components/Navbar";
import Footer from "@/views/components/Footer";
import HeroStart from "@/views/components/HeroStart";

import BootstrapVue from "bootstrap-vue";
import { messages } from "./locale";

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL =
  "https://korkeakoulu.kopiraittila.fi/wp-json/wp/v2/";

// Vue.use(vueSmoothScroll)
Vue.use(BootstrapVue);
Vue.use(VueI18n);

Vue.use(VueMatomo, {
  host: "https://matomo.kopiraittila.fi",
  siteId: 3,
  router: router, // Your Vue Router instance
  enableLinkTracking: true,
  requireConsent: false,
});

Vue.config.productionTip = false;
window.forceSmoothScrollPolyfill = true;

const i18n = new VueI18n({
  locale: "fi",
  messages,
});

/* eslint-disable no-new */
new Vue({
  i18n,
  el: "#app",
  router,
  components: {
    App,
    Navbar,
    Footer,
    HeroStart,
  },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js